import React, { useState, useCallback, useRef } from "react";
import { createAppContainer} from 'react-navigation';
import { createStackNavigator } from 'react-navigation-stack';
import Main from './main';
import Main2 from './main2';
import Info from './info';
import Infoo from './infoo';
import Translate from './translate';
import Translate2 from './translate2';
import Final from './final';
import Fasla from './fasla';
import Fasla2 from './fasla2';
import Final2 from './final2';
import Tfinal from './tfinal';
import Tfinal2 from './tfinal2';
import Last from './last';
import Fin from './fin';
import Aftermain from './aftermain';
import Beforeaftermain from './beforeaftermain';
import Beforeaftermain2 from './beforeaftermain2';
import Aftermain2 from './aftermain2';

const AppNavigator = createStackNavigator(
  {

    Info: {screen: Info},
    Infoo: Infoo,
    Fasla: Fasla,
    Main: Main,
    Beforeaftermain:Beforeaftermain,
    Aftermain:Aftermain,
    Translate: Translate,
    Final: Final,
    Tfinal: Tfinal,
    Fasla2: Fasla2,
    Main2: Main2,
    Beforeaftermain2:Beforeaftermain2,
    Aftermain2:Aftermain2,
    Translate2: Translate2,
    Final2: Final2,
    Tfinal2: Tfinal2,
    Last: Last,
    Fin:Fin,
  },
  {
    /* The header config from HomeScreen is now here */
    defaultNavigationOptions: {
      headerShown: false 
    },
  }
);
const AppContainer = createAppContainer(AppNavigator);

export default AppContainer;

